import React from 'react';
import { string, array } from 'prop-types';
import Slider from 'react-slick';

// Import components
import ItemDetailsNpvr from './ItemDetailsNpvr';
import { Root, SliderContainer, SliderItem, Content } from '../style';
import { CustomArrow } from 'components/elements';
import { RecordingsHeader } from '../RecordingsHeader';

const RecordingsNpvrSlider = (props) => {
	const { name, recordings, itemsToShow } = props;

	return (
		<Root>
			<RecordingsHeader title={name} />
			<SliderContainer>
				<Slider
					infinite={false}
					dots={false}
					rows={1}
					slidesToScroll={itemsToShow}
					slidesToShow={itemsToShow}
					initialSlide={0}
					nextArrow={<CustomArrow direction="right" />}
					prevArrow={<CustomArrow direction="left" />}
				>
					{recordings.map((recording) => (
						<SliderItem key={recording.recordingId} itemsToShow={itemsToShow}>
							<Content>
								<ItemDetailsNpvr {...recording} />
							</Content>
						</SliderItem>
					))}
				</Slider>
			</SliderContainer>
		</Root>
	);
};

RecordingsNpvrSlider.defaultProps = {
	itemsToShow: 4
};

RecordingsNpvrSlider.propTypes = {
	name: string.isRequired,
	recordings: array
};

export default RecordingsNpvrSlider;
